import moment from 'moment-timezone';

const OUTLOOK_COMPOSE_PATH = '/calendar/action/compose';

const OUTLOOK_CLOUD_HOST = 'outlook.cloud.microsoft';

export function buildOutlookComposeUrl({ host, date, startTime, endTime, timezone, subject, location }) {
  if (!date || !startTime || !endTime) return null;

  const tz = timezone || 'America/Los_Angeles';
  const start = moment.tz(`${date} ${startTime}`, 'YYYY-MM-DD h:mm A', tz);
  const end = moment.tz(`${date} ${endTime}`, 'YYYY-MM-DD h:mm A', tz);
  if (!start.isValid() || !end.isValid()) return null;

  const params = new URLSearchParams({
    rru: 'addevent',
    allday: 'false',
    startdt: `${start.utc().format('YYYY-MM-DDTHH:mm:ss')}Z`,
    enddt: `${end.utc().format('YYYY-MM-DDTHH:mm:ss')}Z`,
    subject: subject || 'Soothe session',
    location: location || '',
  });

  return `https://${host}${OUTLOOK_COMPOSE_PATH}?${params.toString()}`;
}

export function outlookCloudUrl(event) {
  return buildOutlookComposeUrl({ ...event, host: OUTLOOK_CLOUD_HOST });
}

export function outlookWorkUrl(event) {
  return buildOutlookComposeUrl({ ...event, host: 'outlook.office.com' });
}
